const prefixes = new Set(['webkit', 'ms', 'o', ''])

export function AddPrefixedEvent (target, type, callback, options = {}) {
	for (const prefix of prefixes) {
		if (!prefix) {
			type = type.toLowerCase()
		}
		target.addEventListener(prefix + type, callback, options)
	}
}

export function RemovePrefixedEvent (target, type, callback, options = {}) {
	for (const prefix of prefixes) {
		if (!prefix) {
			type = type.toLowerCase()
		}
		target.removeEventListener(prefix + type, callback, options)
	}
}

export function OncePollyFilled (target, eventName, options) {
	return new Promise(resolve => {
		const callback = (e) => {
			if (e && e.target !== target) return
			RemovePrefixedEvent(target, eventName, callback, options)
			resolve()
		}
		AddPrefixedEvent(target, eventName, callback, options)
	})
}

export function AnimationEnd (target, options = {}) {
	return OncePollyFilled(target, 'AnimationEnd', options)
}
export function TransitionEnd (target, options = {}) {
	return OncePollyFilled(target, 'TransitionEnd', options)
}

export function AnimationStart (target, options) {
	return OncePollyFilled(target, 'AnimationStart', options)
}

export function commentNode (el, vnode) {
	const comment = document.createComment(' ')

	Object.defineProperty(comment, 'setAttribute', {
		value: () => undefined
	})

	vnode.text = ' '
	vnode.elm = comment
	vnode.isComment = true
	vnode.context = undefined
	vnode.tag = undefined
	vnode.data.directives = undefined

	if (vnode.componentInstance) {
		vnode.componentInstance.$el = comment
	}

	if (el.parentNode) {
		el.parentNode.replaceChild(comment, el)
	}
}

export const normalize = (value) => {
	return value.normalize('NFKD').replace(/[^().\w\s]/g, '')
}

export const highlight = (value, input) => {
	const normalizedInput = normalize(input).trim()
	const normalizedValue = normalize(value)
	const joinedInput = normalizedInput.split(' ').join('|')
	try {
		let matches = normalizedValue.match(new RegExp(joinedInput, 'gi'))
		if (matches) {
			matches = matches.map(match => {
				const indexOf = normalizedValue.indexOf(match)
				return value.slice(indexOf, indexOf + match.length)
			})
			matches = matches.join('|')
			return value.replace(new RegExp(matches, 'gi'), str => `<mark>${str}</mark>`)
		}
		return value
	} catch (error) {
		return value
	}
}

export const isPhoneNumber = val =>
	/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/.test(val)

export function disableScroll (state) {
	document.body.style.overflow = state ? 'hidden' : null
}

let supportsPassive_

export function applyPassive (globalObj = window, forceRefresh = false) {
	if (supportsPassive_ === undefined || forceRefresh) {
		let isSupported = false
		try {
			globalObj.document.addEventListener('test', null, {
				get passive () {
					isSupported = true
				}
			})
		} catch (_e) {}
		supportsPassive_ = isSupported
	}
	return supportsPassive_ ? { passive: true } : false
}

export const getSelectValue = (value) => {
	if (!value) {
		return null
	}
	if (typeof value === 'string' || typeof value === 'number') {
		return value
	}
	return value.id || value.name || null
}
